import { Stack } from "@mui/material"
import Label from "./label"

export function Violations({ violations }: { violations: string[] }) {
  return <Stack direction="row" gap={1} flexWrap="wrap">
    {violations.map((v, i2) => <Violation key={i2} violation={v} />)}
  </Stack>
}

function Violation({ violation }: { violation: string }) {
  return <Label variant="outlined" color="error">{violation}</Label>
}